import React, { Component } from 'react';

import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';

import './CanvasEditor.scss';

@inject((stores) => ({
  deleteButton: stores.ConfigStore.deleteButtonCertificate
}))
export default class CanvasObjectDelete extends Component {
  static propTypes = {
    canvas: PropTypes.object,
    deleteButton: MobxPropTypes.objectOrObservableObject
  };

  componentDidMount() {
    this.bindDeleteToKeyboard();
  }

  bindDeleteToKeyboard() {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Delete' || event.key === 'Backspace') {
        this.deleteObject();
      }
    });
  }

  deleteObject() {
    const { canvas } = this.props;
    const activeObjects = canvas.getActiveObjects();

    if (activeObjects.some((obj) => obj.selectable)) {
      canvas.discardActiveObject();
      canvas.remove(...activeObjects);
      canvas.renderAll();
    }
  }

  render() {
    const { deleteButton } = this.props;

    return (
      <span
        onClick={() => this.deleteObject()}
        style={deleteButton}
        className="canvas-edit__delete-button"
      >
        {'\u2715'}
      </span>
    );
  }
}
